"use client";

import { c as _c } from "react/compiler-runtime";
import TransferToggle from "@/components/nft-transfer/TransferToggle";
import UserAddressesSelectDropdown from "@/components/user/utils/addresses-select/UserAddressesSelectDropdown";
import CommonSelect, { CommonSelectItem } from "@/components/utils/select/CommonSelect";
import { CollectedCollectionType, CollectionSeized, CollectionSort } from "@/entities/IProfile";
import { MemeSeason } from "@/entities/ISeason";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RefObject, useEffect, useRef, useState } from "react";
import { ProfileCollectedFilters } from "../UserPageCollected";
import { COLLECTED_COLLECTIONS_META } from "./user-page-collected-filters.helpers";
import UserPageCollectedFiltersNativeDropdown from "./UserPageCollectedFiltersNativeDropdown";
import UserPageCollectedFiltersNetworkCollection from "./UserPageCollectedFiltersNetworkCollection";
import UserPageCollectedFiltersSeized from "./UserPageCollectedFiltersSeized";
import UserPageCollectedFiltersSortBy from "./UserPageCollectedFiltersSortBy";
import UserPageCollectedFiltersSzn from "./UserPageCollectedFiltersSzn";
enum MainTab {
  NATIVE = "NATIVE",
  NETWORK = "NETWORK",
}
export default function UserPageCollectedFilters(t0) {
  const $ = _c(66);
  const {
    profile,
    filters,
    containerRef,
    setCollection,
    setSortBy,
    setSeized,
    setSzn,
    setSubcollection,
    showTransfer
  } = t0;
  const scrollContainerRef = useRef(null);
  const contentContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const container = scrollContainerRef.current;
      if (!container) {
        return;
      }
      const {
        scrollLeft,
        scrollWidth,
        clientWidth
      } = container;
      setCanScrollLeft(scrollLeft > 0);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const checkScroll = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const container_0 = scrollContainerRef.current;
      const contentContainer = contentContainerRef.current;
      if (!container_0) {
        return;
      }
      checkScroll();
      container_0.addEventListener("scroll", checkScroll);
      window.addEventListener("resize", checkScroll);
      const resizeObserver = new ResizeObserver(() => {
        checkScroll();
      });
      resizeObserver.observe(container_0);
      if (contentContainer) {
        resizeObserver.observe(contentContainer);
      }
      return () => {
        container_0.removeEventListener("scroll", checkScroll);
        window.removeEventListener("resize", checkScroll);
        resizeObserver.disconnect();
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const container_1 = scrollContainerRef.current;
      if (!container_1) {
        return;
      }
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          checkScroll();
        });
      });
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== filters.collection) {
    t5 = [filters.collection];
    $[4] = filters.collection;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      const container_2 = scrollContainerRef.current;
      if (!container_2) {
        return;
      }
      container_2.scrollBy({
        left: -150,
        behavior: "smooth"
      });
    };
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const scrollLeft_0 = t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      const container_3 = scrollContainerRef.current;
      if (!container_3) {
        return;
      }
      container_3.scrollBy({
        left: 150,
        behavior: "smooth"
      });
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const scrollRight = t7;
  const getShowSeized = _temp;
  const getShowSzn = _temp2;
  const activeMainTab = filters.collection === CollectedCollectionType.NETWORK ? MainTab.NETWORK : MainTab.NATIVE;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [{
      label: "Native",
      value: MainTab.NATIVE,
      key: MainTab.NATIVE
    }, {
      label: "Network",
      value: MainTab.NETWORK,
      key: MainTab.NETWORK
    }];
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const mainTabItems = t8;
  let t9;
  if ($[9] !== activeMainTab || $[10] !== setCollection) {
    t9 = tab => {
      if (tab === MainTab.NATIVE) {
        if (activeMainTab !== MainTab.NATIVE) {
          setCollection(null);
        }
      } else {
        setCollection(CollectedCollectionType.NETWORK);
      }
    };
    $[9] = activeMainTab;
    $[10] = setCollection;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleMainTabChange = t9;
  let t10;
  if ($[12] !== showTransfer) {
    t10 = showTransfer && <TransferToggle />;
    $[12] = showTransfer;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== activeMainTab || $[15] !== handleMainTabChange) {
    t11 = <CommonSelect items={mainTabItems} activeItem={activeMainTab} setSelected={handleMainTabChange} filterLabel="View" />;
    $[14] = activeMainTab;
    $[15] = handleMainTabChange;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== activeMainTab || $[18] !== filters.collection || $[19] !== setCollection) {
    t12 = activeMainTab === MainTab.NATIVE && <UserPageCollectedFiltersNativeDropdown selected={filters.collection} setSelected={setCollection} />;
    $[17] = activeMainTab;
    $[18] = filters.collection;
    $[19] = setCollection;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== activeMainTab || $[22] !== filters.handleOrWallet || $[23] !== filters.subcollection || $[24] !== setSubcollection) {
    t13 = activeMainTab === MainTab.NETWORK && <UserPageCollectedFiltersNetworkCollection identity={filters.handleOrWallet} selected={filters.subcollection} setSelected={setSubcollection} />;
    $[21] = activeMainTab;
    $[22] = filters.handleOrWallet;
    $[23] = filters.subcollection;
    $[24] = setSubcollection;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== filters.collection || $[27] !== filters.sortBy || $[28] !== filters.sortDirection || $[29] !== setSortBy) {
    t14 = <UserPageCollectedFiltersSortBy selected={filters.sortBy} direction={filters.sortDirection} collection={filters.collection} setSelected={setSortBy} />;
    $[26] = filters.collection;
    $[27] = filters.sortBy;
    $[28] = filters.sortDirection;
    $[29] = setSortBy;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== containerRef || $[32] !== filters.collection || $[33] !== filters.seized || $[34] !== setSeized) {
    t15 = getShowSeized(filters.collection) && <UserPageCollectedFiltersSeized selected={filters.seized} containerRef={containerRef} setSelected={setSeized} />;
    $[31] = containerRef;
    $[32] = filters.collection;
    $[33] = filters.seized;
    $[34] = setSeized;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== filters.collection || $[37] !== filters.initialSznId || $[38] !== filters.szn || $[39] !== setSzn) {
    t16 = getShowSzn(filters.collection) && <UserPageCollectedFiltersSzn selected={filters.szn} initialSeasonId={filters.initialSznId} setSelected={setSzn} />;
    $[36] = filters.collection;
    $[37] = filters.initialSznId;
    $[38] = filters.szn;
    $[39] = setSzn;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13 || $[45] !== t14 || $[46] !== t15 || $[47] !== t16) {
    t17 = <div className="tw-flex tw-nowrap tw-gap-x-3 lg:tw-gap-x-4 tw-items-center tw-flex-shrink-0">{t10}{t11}{t12}{t13}{t14}{t15}{t16}</div>;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== containerRef || $[50] !== filters.collection || $[51] !== profile) {
    t18 = filters.collection !== CollectedCollectionType.NETWORK && <UserAddressesSelectDropdown wallets={profile.wallets ?? []} containerRef={containerRef} onActiveAddress={_temp3} />;
    $[49] = containerRef;
    $[50] = filters.collection;
    $[51] = profile;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== t18) {
    t19 = <div className="tw-flex-shrink-0">{t18}</div>;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  let t20;
  if ($[55] !== t17 || $[56] !== t19) {
    t20 = <div ref={scrollContainerRef} className="tw-w-full tw-overflow-x-auto [&::-webkit-scrollbar]:tw-hidden [-ms-overflow-style:none] [scrollbar-width:none]"><div ref={contentContainerRef} className="tw-flex tw-nowrap tw-justify-between tw-gap-x-3 lg:tw-gap-x-4 tw-items-center tw-w-full tw-min-w-max">{t17}{t19}</div></div>;
    $[55] = t17;
    $[56] = t19;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== canScrollLeft) {
    t21 = canScrollLeft && <><div className="tw-absolute tw-left-0 tw-top-0 tw-bottom-0 tw-w-24 tw-pointer-events-none tw-z-10 tw-bg-gradient-to-r tw-from-black tw-via-black/40 tw-to-black/0" /><button onClick={scrollLeft_0} aria-label="Scroll filters left" className="tw-absolute tw-left-0 tw-top-1/2 tw--translate-y-1/2 tw-z-20 tw-inline-flex tw-items-center tw-justify-start tw-group tw-p-0 tw-h-10 tw-w-10 tw-bg-transparent tw-border-none tw-outline-none"><FontAwesomeIcon icon={faChevronLeft} className="tw-h-6 tw-w-6 tw-text-iron-200 group-hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out" /></button></>;
    $[58] = canScrollLeft;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== canScrollRight) {
    t22 = canScrollRight && <><div className="tw-absolute tw-right-0 tw-top-0 tw-bottom-0 tw-w-24 tw-pointer-events-none tw-z-10 tw-bg-gradient-to-l tw-from-black tw-via-black/40 tw-to-black/0" /><button onClick={scrollRight} aria-label="Scroll filters right" className="tw-absolute tw-right-0 tw-top-1/2 tw--translate-y-1/2 tw-z-20 tw-inline-flex tw-items-center tw-justify-end tw-group tw-p-0 tw-h-10 tw-w-10 tw-bg-transparent tw-border-none tw-outline-none"><FontAwesomeIcon icon={faChevronRight} className="tw-h-6 tw-w-6 tw-text-iron-200 group-hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out" /></button></>;
    $[60] = canScrollRight;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t20 || $[63] !== t21 || $[64] !== t22) {
    t23 = <div className="tw-relative tw-w-full">{t20}{t21}{t22}</div>;
    $[62] = t20;
    $[63] = t21;
    $[64] = t22;
    $[65] = t23;
  } else {
    t23 = $[65];
  }
  return t23;
}
function _temp3() {}
function _temp2(collection_0) {
  return collection_0 ? COLLECTED_COLLECTIONS_META[collection_0].filters.szn : false;
}
function _temp(collection) {
  return collection ? COLLECTED_COLLECTIONS_META[collection].filters.seized : false;
}